<!--Image-->
<div id="MainImageDiv" class="ImageDiv">
	<img id="MainImage" [src]="ImageData" />
</div>

<!--Rotate image-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onRotateLeft()"><i class="fa fa-undo" style="margin-right: 7px" aria-hidden="true"></i>Rotate</button>
	<button class="btn btn-primary" (click)="onRotateRight()">Rotate<i class="fa fa-repeat" style="margin-left: 7px" aria-hidden="true"></i></button>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
